import React, { useState, useEffect } from "react";
import '../../styles/ModuleManagement.css'; // Optional, for styling
import Swal from 'sweetalert2';
import { formatCurrencyUSD } from "../../utils/format";

const ModuleSummary = () => {

     const [resultHistoryHeaderTrans, setResultHistoryHeaderTrans] = useState([]);
        const [resultHistoryDetailsTrans, setResultHistoryDetailsTrans] = useState([]);
        const [isVisible, setIsVisible] = useState(false);
        const [isModalAddModuleOpen, setIsAddModuleOpen] = useState(false);
        const [isModalEditModuleOpen, setIsEditModuleOpen] = useState(false);
        const [isModalViewModuleOpen, setIsViewModuleOpen] = useState(false);
        const [sortDirection, setSortDirection] = useState('asc'); // 'asc' or 'desc'
        const [sortColumn, setSortColumn] = useState(null);
        const [createdByFilter, setCreatedByFilter] = useState('');
        const [clientNameFilter, setClientNameFilter] = useState('');
        const [dateFromFilter, setDateFromFilter] = useState('');
        const [dateToFilter, setDateToFilter] = useState('');
        const [filteredHistoryHeaderTrans, setFilteredHistoryHeaderTrans] = useState([]);
    
    
        const fetchPaymentChangeHeaders = async () => {
            try {
            setIsVisible(true); // Show loading data section
            const response = await fetch(`https://eo74xuizbkxwqnj.m.pipedream.net/api/PaymentChangeHistory/GetAllPaymentChangeHeaders`);
            if (!response.ok) throw new Error('Failed to fetch payment change headers');
            
            const data = await response.json();
    
            
            const allocationHistoryTrans = getChangeHistoryHeaderTransactions(data);
            setResultHistoryHeaderTrans(allocationHistoryTrans);
            setIsVisible(false); // Show loading data section
            } catch (err) {
            console.error('Error fetching payment change headers:', err);
            }
        };
    
        const [showTable, setShowTable] = useState(false);
        const handleViewModule = async (headerId) => {
            try {
            setShowTable(false); //  Hide the table immediately
            setResultHistoryDetailsTrans([]); // Clear previous data
            setIsViewModuleOpen(true);
            setIsVisible(true);
    
            // const response = await fetch(`https://eozaol3a92fwx3h.m.pipedream.net/api/PaymentChangeHistory/GetAllPaymentChangeDetailsByHeaderID?headerid=${headerId}`);
            // const data = await response.json();
    
            // const allocationHistoryTrans = getChangeHistoryDetailsTransactions(data);
            // setResultHistoryDetailsTrans(allocationHistoryTrans);
    
            setIsVisible(false);
            setShowTable(true); //  Show the table after data is loaded
            } catch (error) {
            console.error('Error fetching header details:', error);
            setIsVisible(false);
            }
        };

        const handleAddModule = async () => {
            try {
            setShowTable(false); //  Hide the table immediately
            setResultHistoryDetailsTrans([]); // Clear previous data
            setIsAddModuleOpen(true);
            setIsVisible(true);
    
            //const response = await fetch(`https://eozaol3a92fwx3h.m.pipedream.net/api/PaymentChangeHistory/GetAllPaymentChangeDetailsByHeaderID?headerid=${headerId}`);
            //const data = await response.json();
    
            //const allocationHistoryTrans = getChangeHistoryDetailsTransactions(data);
            //setResultHistoryDetailsTrans(allocationHistoryTrans);
    
            setIsVisible(false);
            setShowTable(true); //  Show the table after data is loaded
            } catch (error) {
            console.error('Error fetching header details:', error);
            setIsVisible(false);
            }
        };

        const handleEditModule = async (headerId) => {
            try {
            setShowTable(false); //  Hide the table immediately
            setResultHistoryDetailsTrans([]); // Clear previous data
            setIsEditModuleOpen(true);
            setIsVisible(true);
    
            // const response = await fetch(`https://eozaol3a92fwx3h.m.pipedream.net/api/PaymentChangeHistory/GetAllPaymentChangeDetailsByHeaderID?headerid=${headerId}`);
            // const data = await response.json();
    
            // const allocationHistoryTrans = getChangeHistoryDetailsTransactions(data);
            // setResultHistoryDetailsTrans(allocationHistoryTrans);
    
            setIsVisible(false);
            setShowTable(true); //  Show the table after data is loaded
            } catch (error) {
            console.error('Error fetching header details:', error);
            setIsVisible(false);
            }
        };
    
         const getChangeHistoryHeaderTransactions = (changeHistoryHeaderTrans) => {
          const transLog = [];
          let counterID = 1;
    
          //  Step 1: Sort input array by ScheduleDateAdjusted (ClearedDate)
          const sortedTrans = [...changeHistoryHeaderTrans].sort((a, b) => {
            const dateA = a.App_Created_Date ? new Date(a.App_Created_Date) : new Date(0); // fallback for nulls
            const dateB = b.App_Created_Date ? new Date(b.App_Created_Date) : new Date(0);
            return dateA - dateB; // ascending order
          });
    
          //  Step 2: Process sorted data
          for (let m = 0; m < sortedTrans.length; m++) {
            const item = sortedTrans[m];
    
            const formattedCreateDateOriginal = item.App_Created_Date
              ? item.App_Created_Date.split('T')[0]
              : 'N/A';
    
            // const formattedDateScheduleDateAdjusted = item.ScheduleDateAdjusted
            //   ? item.ScheduleDateAdjusted.split('T')[0]
            //   : 'N/A';
    
            transLog.push({
              CounterID: counterID++,
              HeaderID: item.PCH_Header_ID,
              TotalCount: item.Total_Count,
              ContactID : item.Contact_ID,
              ClientID : item.Client_ID,
              ExternalID : item.External_ID,
              ClientName : item.Client_Name,
              CreatedBy: item.Created_By,
              CreatedDate: formattedCreateDateOriginal
              //TransactionStatus: item.TransactionStatus
            });
          }
    
          return transLog;
        };
    
    
        const getChangeHistoryDetailsTransactions = (changeHistoryDetailsTrans) => {
          const transLog = [];
    
          //  Step 1: Sort input array by ScheduleDateAdjusted (ClearedDate)
          const sortedTrans = [...changeHistoryDetailsTrans].sort((a, b) => {
            const dateA = a.Created_Date ? new Date(a.Created_Date) : new Date(0); // fallback for nulls
            const dateB = b.Created_Date ? new Date(b.Created_Date) : new Date(0);
            return dateA - dateB; // ascending order
          });
    
          //  Step 2: Process sorted data
          for (let m = 0; m < sortedTrans.length; m++) {
            const item = sortedTrans[m];
    
            transLog.push({
              DetailsID : item.PCH_Details_ID,
              HeaderID : item.PCH_Header_ID,
              ItemNo : item.Item_No,
              ContactID : item.Contact_ID,
              ClientID : item.Client_ID,
              ExternalID : item.External_ID,
              ClientName : item.Client_Name,
              DebtID : item.Debt_ID,
              TransID : item.Trans_ID,
              ClearedDate : item.Cleared_Date,
              Transaction : item.Transaction,
              OrigAmount : item.Orig_Amount,
              OrigStatus : item.Orig_Status,
              OrigEndingBalance : item.Orig_Ending_Balance,
              ProposedAmount : item.Proposed_Amount,
              ProposedNewEndingBalance : item.Proposed_New_Ending_Balance,
              FinalizedAmount : item.Finalized_Amount,
              FinalizedNewEndingBalance : item.Finalized_Ending_Balance,
              CreatedBy : item.Created_By,
              CreatedDate : item.Created_Date,
              UpdatedBy : item.Updated_By,
              UpdatedDate : item.Updated_Date,
              CreatedTimeStamp : item.Created_Time_Stamp
            });
          }
    
          return transLog;
        };
    
        const filterHistoryData = (data, createdBy, clientName, dateFrom, dateTo) => {
          return data.filter(item => {
            if (createdBy && !item.CreatedBy.toLowerCase().includes(createdBy.toLowerCase())) return false;
            if (clientName && !item.ClientName.toLowerCase().includes(clientName.toLowerCase())) return false;
            if (item.CreatedDate === 'N/A') return false;
            const itemDate = new Date(item.CreatedDate);
            const fromDate = dateFrom ? new Date(dateFrom) : null;
            const toDate = dateTo ? new Date(dateTo) : null;
            if (fromDate && itemDate < fromDate) return false;
            if (toDate && itemDate > toDate) return false;
            return true;
          });
        };
    
        useEffect(() => {
            fetchPaymentChangeHeaders();
        }, []);
    
        useEffect(() => {
          const filtered = filterHistoryData(resultHistoryHeaderTrans, createdByFilter, clientNameFilter, dateFromFilter, dateToFilter);
          setFilteredHistoryHeaderTrans(filtered);
        }, [resultHistoryHeaderTrans, createdByFilter, clientNameFilter, dateFromFilter, dateToFilter]);
    
    
        const Modal = ({ isOpen, onClose, children }) => {
            if (!isOpen) return null;
    
            return (
            <div className="reg-modal-overlay">
                <div className="modal modal-md">
                <button className="modal-close" onClick={onClose}>×</button>
                <div className="modal-content">{children}</div>
                </div>
            </div>
            );
        };
    
        // Column mapping for sorting
        const columnMappingHeaders = {
            'CounterID': 'CounterID',
            'HeaderID': 'HeaderID',
            'TotalCount': 'TotalCount',
            'ContactID': 'ContactID',
            'ClientID': 'ClientID',
            'ExternalID': 'ExternalID',
            'ClientName': 'ClientName',
            'CreatedBy': 'CreatedBy',
            'CreatedDate': 'CreatedDate'
        };
    
        // Function to handle sorting
        const handleSortChangeHistoryHeaders = (column) => {
            const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
            setSortDirection(newDirection);
            setSortColumn(column);
    
            const actualColumn = columnMappingHeaders[column];
    
            const sortedData = [...resultHistoryHeaderTrans].sort((a, b) => {
            let aVal = a[actualColumn];
            let bVal = b[actualColumn];
    
            // Handle 'N/A' as null
            if (aVal === 'N/A') aVal = null;
            if (bVal === 'N/A') bVal = null;
    
            // Type-specific handling
            if (actualColumn === 'CreatedDate') {
                aVal = aVal ? new Date(aVal) : new Date(0); // Old date for 'N/A'
                bVal = bVal ? new Date(bVal) : new Date(0);
            } else {
                // Strings
                aVal = aVal || '';
                bVal = bVal || '';
            }
    
            if (newDirection === 'asc') {
                if (aVal < bVal) return -1;
                if (aVal > bVal) return 1;
                return 0;
            } else {
                if (aVal > bVal) return -1;
                if (aVal < bVal) return 1;
                return 0;
            }
            });
    
            setResultHistoryHeaderTrans(sortedData);
        };
    
    
         // Column mapping for sorting
        const columnMappingDetails = {
            'ItemNo': 'ItemNo',
            'DebtID': 'DebtID',
            'TransID': 'TransID',
            'ClearedDate': 'ClearedDate',
            'Transaction': 'TableName',
            'Amount': 'Amount',
            'Status': 'TransactionStatus',
            'EndingBalance': 'EndingBalance',
            'ProposedAmount': 'ProposedAmount',
            'ProposedNewEndingBalance': 'ProposedNewEndingBalance',
            'FinalizedAmount': 'FinalizedAmount',
            'FinalizedNewEndingBalance': 'FinalizedNewEndingBalance',
        };
    
        // Function to handle sorting
        const handleSortChangeHistoryDetails = (column) => {
            const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
            setSortDirection(newDirection);
            setSortColumn(column);
    
            const actualColumn = columnMappingDetails[column];
    
            const sortedData = [...resultHistoryDetailsTrans].sort((a, b) => {
            let aVal = a[actualColumn];
            let bVal = b[actualColumn];
    
            // Handle 'N/A' as null
            if (aVal === 'N/A') aVal = null;
            if (bVal === 'N/A') bVal = null;
    
            // Type-specific handling
            if (actualColumn === 'CreatedDate') {
                aVal = aVal ? new Date(aVal) : new Date(0); // Old date for 'N/A'
                bVal = bVal ? new Date(bVal) : new Date(0);
            } else {
                // Strings
                aVal = aVal || '';
                bVal = bVal || '';
            }
    
            if (newDirection === 'asc') {
                if (aVal < bVal) return -1;
                if (aVal > bVal) return 1;
                return 0;
            } else {
                if (aVal > bVal) return -1;
                if (aVal < bVal) return 1;
                return 0;
            }
            });
    
            setResultHistoryDetailsTrans(sortedData);
        };
    
    
    
    
        return (
        <div className="debt-summary-trans-table">
          <div className="flex-container">
            <div className="column">
              <label className="container-headtitle">Modules Summary</label>
              <div className="filters-section">
                <div className="filters-row">
                  <div className="filter-group">
                    <label>Module Name:</label>
                    <input
                      type="text"
                      value={clientNameFilter}
                      onChange={(e) => setClientNameFilter(e.target.value)}
                      placeholder="Filter by Module Name"
                    />
                  </div>
                  <div className="filter-group">
                    <label>From Date:</label>
                    <input
                      type="date"
                      value={dateFromFilter}
                      onChange={(e) => setDateFromFilter(e.target.value)}
                    />
                  </div>
                  <div className="filter-group">
                    <label>To Date:</label>
                    <input
                      type="date"
                      value={dateToFilter}
                      onChange={(e) => setDateToFilter(e.target.value)}
                    />
                  </div>
                  <button
                    className="btn"
                    style={{ marginLeft: '10px', height: '40px', alignSelf: 'flex-end', position: 'relative', top: '20px', backgroundColor: '#fc8484ff' }}
                    onClick={() => {
                      setCreatedByFilter('');
                      setClientNameFilter('');
                      setDateFromFilter('');
                      setDateToFilter('');
                    }}
                  >
                    Clear Filters
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => handleAddModule()}
                    style={{ marginLeft: '10px', height: '40px', alignSelf: 'flex-end', position: 'relative', top: '20px'}}
                    >
                    Add New Module
                  </button>
                </div>
              </div>
                {isVisible && (<span className="spinner"></span>)}
                <div className="table-container auto-height-container">
                    {filteredHistoryHeaderTrans.length > 0 ? (
                      <table className="table-bordered scrollable-table">
                        <thead>
                          <tr>
                            <th onClick={() => handleSortChangeHistoryHeaders('CounterID')} title="Sort by Item #">
                              Item # {sortColumn === 'CounterID' && (sortDirection === 'asc' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => handleSortChangeHistoryHeaders('ModuleID')} title="Sort by Module ID">
                              Module ID {sortColumn === 'ModuleID' && (sortDirection === 'asc' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => handleSortChangeHistoryHeaders('ModuleName')} title="Sort by Module Name">
                              Module Name {sortColumn === 'ModuleName' && (sortDirection === 'asc' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => handleSortChangeHistoryHeaders('Status')} title="Sort by Status">
                              Status {sortColumn === 'Status' && (sortDirection === 'asc' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => handleSortChangeHistoryHeaders('CreatedBy')} title="Sort by Created By">
                              Created By {sortColumn === 'CreatedBy' && (sortDirection === 'asc' ? '↑' : '↓')}
                            </th>
                            <th onClick={() => handleSortChangeHistoryHeaders('CreatedDate')} title="Sort by Created Date">
                              Created Date {sortColumn === 'CreatedDate' && (sortDirection === 'asc' ? '↑' : '↓')}
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredHistoryHeaderTrans
                            .map(row => (
                              <tr
                                key={row.CounterID}
                              >
                                <td>{row.CounterID}</td>
                                <td>{row.ModuleID || 'S5TT456T36346'}</td>
                                <td>{row.ModuleName || 'MODULE NAME'}</td>
                                <td>{row.Status || 'ACTIVE - UNDER MAINTENANCE'}</td>
                                <td>{row.CreatedBy || 'N/A'}</td>
                                <td>{row.CreatedDate || 'N/A'}</td>
                                <td>
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => handleViewModule(row.HeaderID)}
                                    >
                                      View
                                  </button>
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => handleEditModule(row.HeaderID)}
                                    >
                                      Edit
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    ) : resultHistoryHeaderTrans.length > 0 ? (
                      <p>No data matches the filters</p>
                    ) : (
                      <p>No data available</p>
                    )}
                </div>
    
               <Modal isOpen={isModalAddModuleOpen} onClose={() => setIsAddModuleOpen(false)}>
                    <h2>Add Module</h2>
                    <hr/>
                    <h3>Overview</h3>
                    <p>You may able to add new modules here. Fill up all required fields.</p>
                  
                    {isVisible && (<span className="spinner"></span>)}
                </Modal>
                <Modal isOpen={isModalEditModuleOpen} onClose={() => setIsEditModuleOpen(false)}>
                    <h2>Edit Module</h2>
                    <hr/>
                    <h3>Overview</h3>
                    <p>You may able to edit existing modules here. Fill up all required fields.</p>
                  
                    {isVisible && (<span className="spinner"></span>)}
                </Modal>
                <Modal isOpen={isModalViewModuleOpen} onClose={() => setIsViewModuleOpen(false)}>
                    <h2>View Module</h2>
                    <hr/>
                    <h3>Overview</h3>
                    <p>You may only to view existing modules here.</p>
                  
                    {isVisible && (<span className="spinner"></span>)}
                </Modal>
            </div> 
          </div> 
        </div> 
        )
};

export default ModuleSummary;